module.exports = __webpack_public_path__ + "static/img/decomposers_ocean.eb64f7ce.png";